import { createRoute } from '@tanstack/react-router';
import { IconCoin } from '@tabler/icons-react';
import type { EzyModule } from '../module';
import { readFinanceAccess } from '../finance/access';
import { ArRoute } from './ArRoute';
import { InvoiceRoute } from './InvoiceRoute';
import { InvoiceDetail } from './InvoiceDetail';

/** Luồng L (Công nợ · Hoá đơn · Thanh toán · BOD): mọi màn sau quyền `money` (guard của K) — menu chỉ hiện cho người có quyền. */
const ledger: EzyModule = {
  nav: typeof location !== 'undefined' && readFinanceAccess(location.search).money
    ? { key: 'ledger', label: 'Công nợ', icon: IconCoin, items: [{ key: 'ar', label: 'Công nợ', to: '/ezy/ar' }, { key: 'invoice', label: 'Hoá đơn', to: '/ezy/invoice' }] }
    : undefined,
  routes: (parent) => [createRoute({ getParentRoute: () => parent, path: '/ar', component: ArRoute }), createRoute({ getParentRoute: () => parent, path: '/invoice', component: InvoiceRoute }), createRoute({ getParentRoute: () => parent, path: '/invoice/$doc', component: InvoiceDetail })],
};
export default ledger;
